import { useQuery } from "@tanstack/react-query";
import type { FC, PropsWithChildren } from "react";
import React from "react";

import { hasValue, isNullish } from "@core/foundation/types";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";

import { FIRST_GRID_EPOCH } from "@apis/calorie-grid/models";

import { ConfigContext } from "../../../shared/contexts/config/context.ts";
import { useUnconfiguredQueries } from "../../../shared/hooks/useUnconfiguredQueries.ts";

export const ConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const { getEpochQueryOptions, getGridConfigQueryOptions } =
    useUnconfiguredQueries();

  const epoch = useQuery(getEpochQueryOptions());

  const gridEpochId = epoch.data?.gridEpochId;
  const gridConfig = useQuery({
    ...getGridConfigQueryOptions(gridEpochId ?? FIRST_GRID_EPOCH),
    enabled: hasValue(gridEpochId),
  });

  if (epoch.status === "error" || gridConfig.status === "error") {
    return <ErrorView />;
  }

  if (
    isNullish(epoch.data) ||
    isNullish(gridConfig.data) ||
    gridConfig.data.gridEpochId !== epoch.data.gridEpochId
  ) {
    return <LoadingView />;
  }

  return (
    <ConfigContext.Provider
      value={{
        epochId: epoch.data.epochId,
        gridEpochId: epoch.data.gridEpochId,
        squareKcal: gridConfig.data.squareKcal,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
